interface CustomClassContainerProps {
  classes?: string[];
  children?: React.ReactNode;
}

const CustomClassContainer = ({
  children,
  classes,
}: CustomClassContainerProps) => {
  function getCustomClasses() {
    return classes ? classes.join(' ') : '';
  }

  return <div className={getCustomClasses()}>{children}</div>;
};

export { CustomClassContainer };
export type { CustomClassContainerProps };
